'use client';

import { useLocale } from 'next-intl';
import { localizeMessages } from '@/libs/campaigns/messages';
import { useActiveSkin } from '../ActiveCampaignProvider';

type CampaignShopAccents = {
  /** The badge label next to Shop in the sidebar, or `null` for no badge. */
  promoBadge: string | null;
  /** The emoji after the Shop section titles, or `null` for none. */
  sectionTitleEmoji: string | null;
};

/** The Active Campaign's Shop accents; without an Active Campaign there are none. */
export function useCampaignShop(): CampaignShopAccents {
  const shop = useActiveSkin()?.shop;
  const locale = useLocale();

  if (!shop) {
    return { promoBadge: null, sectionTitleEmoji: null };
  }

  return {
    promoBadge: shop.promoBadge ? localizeMessages(shop.messages, locale).promoBadge : null,
    sectionTitleEmoji: shop.sectionTitleEmoji ?? null,
  };
}
